import { millisecondsToHours } from "@pentacode/openapi";
import { getTimeBetweenDates } from "../utils";
import { hour } from "./consts";
export const nullInterval = [new Date(0), new Date(0)];
export function union(intervals) {
    const itvs = [...intervals].sort(([a], [b]) => a.getTime() - b.getTime());
    for (let i = 0; i < itvs.length - 1;) {
        if (itvs[i][1].getTime() >= itvs[i + 1][1].getTime()) {
            // If the current interval ends at or after the next intervals end, remove the next interval
            itvs.splice(i + 1, 1);
        }
        else if (itvs[i][1].getTime() >= itvs[i + 1][0].getTime()) {
            // if the current interval ends after the next interval starts
            // delete the next interval
            // insert new interval with the start of the current interval and the end of the next interval
            itvs.splice(i, 2, [itvs[i][0], itvs[i + 1][1]]);
        }
        else {
            i++;
        }
    }
    return itvs;
}
// returns the intersection of intervals
export function intersect(a, b) {
    // latest start date
    const start = new Date(Math.max(a[0].getTime(), b[0].getTime()));
    // earliest end date, but not earlier than start
    const end = new Date(Math.max(start.getTime(), Math.min(a[1].getTime(), b[1].getTime())));
    return [start, end];
}
export function intersectAll(all) {
    const [one, two, ...rest] = all;
    if (!one) {
        return [];
    }
    if (!two) {
        return one;
    }
    // create a.length * b.length intersections, then reduce them by union
    const intersects = [];
    for (const a of one) {
        for (const b of two) {
            intersects.push(intersect(a, b));
        }
    }
    const result = union(intersects);
    // recursive call to intersect the resulting intervals with the remaining Arrays of intervals
    return intersectAll([result, ...rest]);
}
export function subtractIntervals(a, b) {
    return (
    /*
     * |---|
     *       |---|
     */
    a[0].getTime() >= b[1].getTime() || a[1].getTime() <= b[0].getTime()
        ? [a]
        : /*
           *   |---|
           * |-------|
           */
            a[0].getTime() >= b[0].getTime() && a[1].getTime() <= b[1].getTime()
                ? []
                : /*
                   * |-------|
                   *   |---|
                   */
                    a[0].getTime() < b[0].getTime() && a[1].getTime() > b[1].getTime()
                        ? [
                            [a[0], b[0]],
                            [b[1], a[1]],
                        ]
                        : /*
                           * |-----|
                           *    |-----|
                           */
                            a[0].getTime() < b[0].getTime() && a[1].getTime() <= b[1].getTime()
                                ? [[a[0], b[0]]]
                                : /*
                                   *    |-----|
                                   * |-----|
                                   */
                                    a[0].getTime() >= b[0].getTime() && a[1].getTime() > b[1].getTime()
                                        ? [[b[1], a[1]]]
                                        : []);
}
export function subtractAllIntervals(a, b) {
    if (!b.length) {
        return a;
    }
    const result = [];
    for (const aInt of a) {
        const tempRes = [];
        for (const bInt of b) {
            tempRes.push(subtractIntervals(aInt, bInt));
        }
        for (const interval of intersectAll(tempRes)) {
            result.push(interval);
        }
    }
    return union(result);
}
// returns the cumulative overlap between a and each b interval in hours
export function overlap(a, b) {
    let result = 0;
    for (const itv of b) {
        result += Math.max(0, Math.min(a[1].getTime(), itv[1].getTime()) - Math.max(a[0].getTime(), itv[0].getTime()));
    }
    return millisecondsToHours(result);
}
// Returns the gap between two non-overlapping intervals in milliseconds, or null
// if they overlap. Touching intervals (one ends exactly when the other starts)
// return 0, not null.
export function getGap(a, b) {
    if (a[1].getTime() <= b[0].getTime())
        return getTimeBetweenDates(a[1], b[0]);
    if (b[1].getTime() <= a[0].getTime())
        return getTimeBetweenDates(b[1], a[0]);
    return null;
}
export function getIntervalDuration(interval) {
    if (!interval || !interval[0] || !interval[1]) {
        return 0;
    }
    const duration = (interval[1].getTime() - interval[0].getTime()) / hour;
    return duration;
}
//# sourceMappingURL=interval.js.map